export default __webpack_public_path__ + "static/media/mobile_pay.16171934.svg";